import { gql } from '@apollo/client';
import { WarrantyErrorInfo } from '../fragments';

export default gql`
  query warrantyError($id: ID) {
    warrantyError(id: $id) {
      ...WarrantyErrorInfo
    }
  }
  ${WarrantyErrorInfo}
`;
